import { useCallback } from 'react'

import { UseHandleDateTimePickerChange } from '../interfaces'

export const useHandleReturnChange: UseHandleDateTimePickerChange = ({ values, setValues, setTouched, touched }) => {
  return useCallback(
    ({ day, month, year, time }) => {
      const updatedDate = new Date(year, month, day, Number(time))
      if (values.endDate?.getTime() === updatedDate.getTime() && values.returnAt === time) {
        return
      }

      setValues((prevValues) => ({
        ...prevValues,
        endDate: updatedDate,
        returnAt: time,
      }))
      setTouched({ ...touched, endDate: true, returnAt: true })
    },
    [values.endDate, values.returnAt, setValues, setTouched],
  )
}
